import { useMemo } from 'react';
import { capitalizeFirstLetter, FieldTypes } from '@common-fe/common-fe';

import { EMPTY_FIELD_VALUE } from '@/common/constants';
import regexp from '@/common/regexp';
import { lockboxReasonTitle, LockboxStatus } from '@/modules/employer/components/Lockbox/lockbox.types';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';

const useReturnMailStatusFields = () => {
  const { originalLockbox } = useLockboxDetailsStore();
  const lockboxStatus = originalLockbox?.lockboxStatus;

  const statusTitle = capitalizeFirstLetter(
    lockboxStatus?.replace(regexp.DASH_SYMBOL, ' ')?.toLowerCase() || ''
  );

  const reasonTitle = useMemo(
    () => (originalLockbox?.reason ? lockboxReasonTitle?.[originalLockbox?.reason] : ''),
    [originalLockbox?.reason]
  );

  const fields = useMemo(() => {
    if (
      lockboxStatus === LockboxStatus.APPROVED
      || lockboxStatus === LockboxStatus.COMPLETED
    ) {
      return [
        {
          type: FieldTypes.Text as const,
          name: 'decision',
          label: 'Decision',
          value: 'Marked as bad address',
        },
        ...(originalLockbox?.notes
          ? [{
              type: FieldTypes.Text as const,
              name: 'note',
              label: 'Note',
              value: originalLockbox.notes,
            }]
          : []),
      ];
    }

    if (lockboxStatus === LockboxStatus.PENDING) {
      return [
        {
          type: FieldTypes.Text as const,
          name: 'reason',
          label: 'Reason',
          value: reasonTitle || EMPTY_FIELD_VALUE,
        },
        {
          type: FieldTypes.Text as const,
          name: 'approvalStatus',
          label: 'Approval status',
          value: statusTitle || EMPTY_FIELD_VALUE,
        },
        {
          type: FieldTypes.Text as const,
          name: 'note',
          label: 'Note',
          value: originalLockbox?.notes || EMPTY_FIELD_VALUE,
        },
      ];
    }

    if (lockboxStatus === LockboxStatus.CANCELED) {
      return [
        {
          type: FieldTypes.Text as const,
          name: 'approvalStatus',
          label: 'Approval status',
          value: statusTitle || EMPTY_FIELD_VALUE,
        },
        {
          type: FieldTypes.Text as const,
          name: 'note',
          label: 'Note',
          value: originalLockbox?.notes || EMPTY_FIELD_VALUE,
        },
      ];
    }

    return [];
  }, [lockboxStatus, originalLockbox, statusTitle, reasonTitle]);

  return fields;
};

export default useReturnMailStatusFields;
